var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 11.0001H5.52778C5.6989 14.167 6.70833 17.2315 8.45278 19.8801C6.26771 19.5369 4.25798 18.4793 2.7378 16.8726C1.21762 15.2659 0.272699 13.2008 0.0507812 11.0001ZM0.0507812 9.00012C0.272699 6.79942 1.21762 4.73429 2.7378 3.12763C4.25798 1.52097 6.26771 0.46334 8.45278 0.120117C6.70833 2.76873 5.6989 5.83326 5.52778 9.00012H0.0507812ZM19.9508 9.00012H14.4738C14.3027 5.83326 13.2932 2.76873 11.5488 0.120117C13.7338 0.46334 15.7436 1.52097 17.2638 3.12763C18.7839 4.73429 19.7289 6.79942 19.9508 9.00012ZM19.9508 11.0001C19.7289 13.2008 18.7839 15.2659 17.2638 16.8726C15.7436 18.4793 13.7338 19.5369 11.5488 19.8801C13.2932 17.2315 14.3027 14.167 14.4738 11.0001H19.9518H19.9508ZM7.53078 11.0001H12.4708C12.3062 13.6996 11.4561 16.3126 10.0008 18.5921C8.54548 16.3126 7.69538 13.6996 7.53078 11.0001ZM7.53078 9.00012C7.69538 6.30063 8.54548 3.68768 10.0008 1.40812C11.4561 3.68768 12.3062 6.30063 12.4708 9.00012H7.53078Z",
    fill: "#EA55FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.070abd71913fc4e419cbcf0c7bc32845.svg";
export { ForwardRef as ReactComponent };